import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { setToken } from '../lib/api';

export const Route = createFileRoute('/auth/callback')({
  component: AuthCallback,
});

const ERROR_LABELS: Record<string, string> = {
  missing_code: '飞书未返回授权码',
  token_exchange_failed: '换取登录凭证失败',
  invalid_profile: '无法解析飞书用户信息',
};

function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const hash = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : '';
    const params = new URLSearchParams(hash);
    const token = params.get('token');
    const err = params.get('error');

    if (token) {
      setToken(token);
      // Strip the token from the URL before navigating away.
      window.history.replaceState(null, '', '/');
      navigate({ to: '/' });
      return;
    }
    setError(err ? (ERROR_LABELS[err] ?? '登录失败') : '登录失败');
  }, [navigate]);

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-3 text-sm">
      {error ? (
        <>
          <p className="text-destructive">{error}</p>
          <button
            type="button"
            onClick={() => navigate({ to: '/login' })}
            className="text-muted-foreground hover:text-foreground underline"
          >
            返回登录
          </button>
        </>
      ) : (
        <p className="text-muted-foreground">登录中…</p>
      )}
    </div>
  );
}
